import React from 'react';
import type { Density, FieldGroup } from '../../types/disclosure';
import { FieldList } from './FieldList';
interface FieldGroupBlockProps {
  group: FieldGroup;
  density: Density;
  showApiNames: boolean;
  /** Max number of columns the field rows flow across on wide screens. */
  columns?: 1 | 2 | 3;
}
export function FieldGroupBlock({
  group,
  density,
  showApiNames,
  columns = 1
}: FieldGroupBlockProps) {
  const hasHeader = Boolean(group.title || group.description);
  return <section aria-label={group.title} data-id="element-1" data-mp="3n5sgvaycxla4">
      {hasHeader && <div className="mb-2 pb-0.5" data-id="element-2" data-mp="3n5992n2f8d9t">
          {group.title && <h3 className="text-[11px] font-bold uppercase tracking-wide text-slate-700 underline decoration-slate-300 decoration-1 underline-offset-4" data-id="element-3" data-mp="3957z8i46hvi7">
              {group.title}
            </h3>}
          {group.description && <p className="mt-0.5 text-xs text-slate-500" data-id="element-4" data-mp="1xpt1vd8251mk">{group.description}</p>}
        </div>}

      <FieldList fields={group.fields} density={density} showApiNames={showApiNames} columns={columns} data-id="element-5" data-mp="22ribqpjjn992" />
    </section>;
}